export enum BeneficiaryCardTypeEnum {
  Neutral = 1,
  New = 2,
  Previous = 3
}
